import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import getColStyle from 'react-grid-system/build/grid/Col/style';
import CommonPropTypes from "./PropTypes";
var DEFAULT_GRID_COLUMNS = 12;

var StatelessCol = /*#__PURE__*/function (_Component) {
  _inherits(StatelessCol, _Component);

  var _super = _createSuper(StatelessCol);

  function StatelessCol() {
    _classCallCheck(this, StatelessCol);

    return _super.apply(this, arguments);
  }

  _createClass(StatelessCol, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          xs = _this$props.xs,
          sm = _this$props.sm,
          md = _this$props.md,
          lg = _this$props.lg,
          xl = _this$props.xl;
      var style = getColStyle({
        width: {
          xs: xs,
          sm: sm,
          md: md,
          lg: lg,
          xl: xl
        },
        screenClass: this.props.screenClass,
        gutterWidth: this.props.gutterWidth,
        gridColumns: DEFAULT_GRID_COLUMNS,
        moreStyle: {
          overflow: 'visible'
        }
      });
      return /*#__PURE__*/React.createElement("div", {
        className: className,
        style: style
      }, children);
    }
  }]);

  return StatelessCol;
}(Component);

_defineProperty(StatelessCol, "propTypes", {
  children: PropTypes.node,
  className: PropTypes.string,
  screenClass: CommonPropTypes.screenClass.isRequired,
  gutterWidth: PropTypes.number,
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number
});

_defineProperty(StatelessCol, "defaultProps", {
  children: null,
  xs: 12,
  sm: 12,
  md: 12,
  lg: 12,
  xl: 12
});

export { StatelessCol as default };